const company = [
    'A0A001',
    'A0A002',
    'A0A003',
    'A0A004',
    'A0A005',
    'A0A006',
    'A0A007',
    'A0A008',
    'A0A009',
    'A0A010',
    'A0A011',
    'A0A012',
    'A0A013',
    'A0A014',
    'A0A015',
]

const entrepreneur = ['A0A102']

const person = ['A0A101']

export const LOCALE_PREFIX = 'scenes.Gnosus.components.GroupStack.components.Content.components.TableContent'

export default {
    entityTypes: {
        person,
        entrepreneur,
        company,
    },
    entityNames: {
        COMPANY: 'company',
        ENTREPRENEUR: 'entrepreneur',
        PERSON: 'person',
        GROUP: 'group',
    },
}
